<script>
import options from "./CustomForm.options"

export default options
</script>

<template>
    <nyk-form
        :form-elements="formElements"
        :form-id="formId"
        :form-guid="formGuid"
        :api-path="apiPath"
        :anti-forgery-token="antiForgeryToken"
        :show-summarized-data="showSummarizedData"
        :summary-confirmation-button-label="summaryConfirmationButtonLabel"
        :summary-cancellation-button-label="summaryCancellationButtonLabel"
        :confirmation-message="confirmationMessage"
        :submit-success-message="submitSuccessMessage"
        :submit-error-message="submitErrorMessage"
        :reset-after-submission="resetAfterSubmission"
        :form-title="formTitle">
    </nyk-form>
</template>